module.exports = __webpack_public_path__ + "53d9d9f5b8c10af44d082ef5bab5575b.png";